export default __webpack_public_path__ + "static/media/download-switch-icon.635b0240.svg";